{
	"close": "Close",
	"number-of-results": "Number of results:",
	"search": "Search",
	"search-here": "Search here",
	"search-no-results": "No results found.",
	"search-placeholder-long": "Search here..",
	"search-results": "Search Results",
	"see-all-results-for": "See all results for "
}
